// extracted by mini-css-extract-plugin
export default {"base":"styles_base__1SYQ1","texts":"styles_texts__nRJWR","description":"styles_description__15ZD-","toggle":"styles_toggle__Qe8yO"};